import { Tag } from 'antd'

import { InvestigationTestStatus } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status?: InvestigationTestStatus
}

const InvestigationStatusMap = {
  [InvestigationTestStatus.NEW]: 'warning',
  [InvestigationTestStatus.APPROVED]: 'success',
  [InvestigationTestStatus.STARTED]: 'processing',
  [InvestigationTestStatus.UNDEFINED]: 'draft',
  [InvestigationTestStatus.SUBMITTED_TO_VALIDATION]: 'processing',
  [InvestigationTestStatus.REJECTED]: 'error'
}
export const TestStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  const color =
    InvestigationStatusMap[status ?? InvestigationTestStatus.UNDEFINED]

  return <Tag color={color}>{t(`tests_results.statuses.${status}`)}</Tag>
}
